export default "__VITE_ASSET__CQV2chlR__"